enum EmailTone {
  CASUAL = "casual",
  FORMAL = "formal",
  FRIENDLY = "friendly",
  NEUTRAL = "neutral",
  PERSUASIVE = "persuasive",
  PROFESSIONAL = "professional",
  URGENT = "urgent",
}

export default EmailTone;
